<template>
  <div v-if="loaded">

    <!-- ── Free preview spent: shared paywall ── -->
    <PreviewPaywall
      v-if="previewBlocked"
      :display-name="user_data.display_name"
      :bg-image="item.pic_hero_parsed"
      :is-logged-in="!!get_me"
    />

    <!-- ── Watchable (subscriber, or preview still running) ── -->
    <div v-if="previewGateOpen">

      <div
        v-show="loaded"
        id="video_page"
        :class="(is_episodes_bar_opened ? 'episodes_bar_opened' : '') + ' ' + (is_user_active ? 'user_active' : 'user_inactive')"
        @mousemove="user_hover()"
        @touchmove="user_hover()"
      >

        <!-- ── Episodes sidebar ── -->
        <div id="episodes_bar" v-if="is_episodes_bar_opened">
          <h1>{{ item.title }}</h1>
          <div class="seasons_menu">
            עונות:
            <ul v-scroll-spy-active="{class: 'active'}" v-scroll-spy-link>
              <li v-for="season in seasons" :key="season.id" @click="scroll_to_season(season.id)">{{ season.num }}</li>
            </ul>
          </div>

          <div class="episodes container" v-scroll-spy>
            <div v-for="season in seasons" :key="season.id" class="section" :id="'ep_season_' + season.id">
              <h3 class="title">עונה {{ season.num }}</h3>

              <div
                class="episode"
                v-for="episode_item in season.episodes"
                :key="episode_item.id"
                :class="(episode_item.id == episode.id ? 'active' : '')"
              >
                <router-link :to="'/item/' + item.id + '/' + episode_item.id + '?autoplay=true'">
                  <div class="pic" :style="'background-image:url(' + episode_item.pic_thumb_parsed + ')'">
                    <div class="user_duration"><span :style="'width:' + episode_item.user_duration_perc + '%'"></span></div>
                  </div>
                  <div class="content">
                    <h3>{{ episode_item.title }}</h3>
                    <h4>{{ episode_item.description }}</h4>
                  </div>
                </router-link>
              </div>

            </div>
          </div>
        </div>

        <!-- ── Geo-block screen ── -->
        <div id="unactive_screen" v-if="!is_country_can_watch">
          <div class="wb-bg" :style="'background-image:url('+ item.pic_hero_parsed +')'"></div>
          <router-link to="/" class="wb-back-btn tov_animate" aria-label="חזור לדף הבית">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </router-link>
          <div class="wb-inner">
            <div class="wb-access-banner" role="alert">
              <div><b>היי {{user_data.display_name}}.</b></div>
              לצערנו השירות לא פועל במדינה שבה אתה נמצא.
            </div>
          </div>
        </div>

        <!-- ── Profile restriction screen ── -->
        <div id="unactive_screen" v-if="item.restricted == true">
          <div class="wb-bg" :style="'background-image:url('+ item.pic_hero_parsed +')'"></div>
          <router-link to="/" class="wb-back-btn tov_animate" aria-label="חזור לדף הבית">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </router-link>
          <div class="wb-inner">
            <div class="wb-access-banner" role="alert">
              <div><b>היי {{user_data.display_name}}.</b></div>
              הסרט חסום לפי הגדרות הפרופיל שלך.
            </div>
          </div>
        </div>

        <!-- ── Chat panel ── -->
        <div id="chat" v-if="chat">
          <Chat :item="item.id"/>
        </div>

        <!-- ── Video wrapper ── -->
        <div
          id="video_wrapper"
          @mouseover="show_controls = true"
          @mouseleave="show_controls = false"
          v-if="previewGateOpen"
        >

          <button
            type="button"
            class="wb-back-btn tov_animate"
            aria-label="חזור אחורה"
            @click="$router.go(-1)"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>

          <div id="rest_bubbles">

            <button
              v-if="player && is_playing && currentTime >= opening_starts && currentTime < opening_ends"
              type="button"
              class="wb-skip-btn"
              @click="$refs.videoPlayer.seek(opening_ends)"
            >דלג על הפתיחה</button>

            <div v-for="rest_item in rest_comp" :key="rest_item.id" class="restriction_item">
              <h3>{{ rest_item.cat.name }}</h3>
              <div class="content">{{ rest_item.description }}</div>
              <button type="button" class="wb-skip-btn" @click="$refs.videoPlayer.seek(rest_item.time_end_seconds)">דלג</button>
            </div>

          </div>

          <div id="movie_titles">
            <h3 v-text="item.title"></h3>
            <h4 v-if="item.title != episode.title" v-text="episode.title"></h4>
          </div>

          <UiVideoPlayer
            ref="videoPlayer"
            :src="videoSrc"
            :poster="episode.pic_thumb_parsed"
            :autoplay="true"
            :controls="true"
            :start-time="startTime"
            :srt-list="episode.srt_list || []"
            @timeupdate="onTimeupdate"
            @pause="save_user_watch_time"
            @ended="save_user_watch_time"
            @playerCreated="onPlayerCreated"
          />

        </div>

      </div>
    </div>

    <md-dialog-prompt
      :md-active.sync="active_problam"
      v-model="problam_val"
      md-title="בואו תספרו לנו מה הבעיה?"
      md-input-maxlength="150"
      md-input-placeholder="הקלד/י את הבעיה..."
      @md-confirm="onConfirm_problam()"
      md-confirm-text="שלח"
      md-cancel-text="בטל" />

  </div>
</template>

<script>
import Chat from '../components/chat.vue';
import UiVideoPlayer from './ui/VideoPlayer.vue';
import PreviewPaywall from './ui/PreviewPaywall.vue';
import previewLimit from '../mixins/previewLimit';

export default {
  components: { Chat, UiVideoPlayer, PreviewPaywall },
  mixins: [previewLimit],

  props: ['user_data', 'profile', 'country_code'],

  data() {
    return {
      updateInterval: false,
      user_token: localStorage.getItem('user_token'),
      auto_skip_rest: [],
      user_watch_time: 0,
      status: '',
      link: '/info/',
      coupon: '',
      problam_val: '',
      active_problam: false,
      coupon_active: false,
      show: true,
      show_dets: true,
      is_user_active: false,
      is_user_active_timer: null,
      opening_starts: 0,
      opening_ends: 0,
      ending_starts: 0,
      show_controls: false,
      chat: true,
      is_episodes_bar_opened: (this.$route.query.is_episodes_bar_opened == 'true'),
      player: null,
      loaded: false,
      id: this.$route.params.id,
      eid: this.$route.params.eid,
      episode: {},
      seasons: [],
      item: {},
      cur_season: {},
      next_episode: {},
    };
  },

  computed: {
    is_user_can_watch() {
      if (!this.get_me) return false;
      return this.get_me.is_active == true;
    },

    previewKey() {
      return this.item && this.item.id ? 'item_' + this.item.id : '';
    },

    startTime() {
      // Watch history is stored for free users too, so resuming a
      // non-subscriber at their saved position would skip straight past the
      // preview limit and paywall them on the first timeupdate.
      if (!this.is_user_can_watch) return 0;
      return this.episode.user_duration > 0 ? this.episode.user_duration : 0;
    },

    is_country_can_watch() {
      return true;
    },

    videoSrc() {
      if (!this.episode || !this.episode.video) return '';
      return this.episode.video;
    },

    is_playing() {
      if (this.isNull(this.player)) return false;
      return (this.player.currentTime() > 0 && this.player.paused() == false && this.player.ended() == false);
    },

    currentTime: {
      get() {
        return this.player ? this.player.currentTime() : 0;
      },
      set(newValue) {
        if (this.player) this.player.currentTime(newValue);
      },
    },

    rest_comp() {
      var arr = [];
      var pre_show_alert = 0;
      if (this.profile.perms_auto_skip == '0' && this.profile.perms_show_alerts == '1') pre_show_alert = 4;

      for (let z in this.episode.restrictions) {
        for (let i in this.episode.restrictions[z].items) {
          let rest_item = this.episode.restrictions[z].items[i];

          if (this.player && this.currentTime >= (rest_item.time_start_seconds - pre_show_alert) && this.currentTime <= rest_item.time_end_seconds) {
            if (this.profile.perms_auto_skip == '1') {
              this.$refs.videoPlayer.seek(rest_item.time_end_seconds + 1);
              return;
            } else if (this.profile.perms_show_alerts == '1') {
              rest_item.cat = this.episode.restrictions[z].data.name;
              arr.push(rest_item);
            }
          }
        }
      }
      return arr;
    },
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.updateInterval);
    this.save_user_watch_time();
    next();
  },

  beforeDestroy() {
    clearInterval(this.updateInterval);
  },

  methods: {
    onConfirm_problam() {
      this.api_call({
        url: 'problem',
        data: { uid: this.get_me.id, eid: this.eid, message: this.problam_val },
        onComplete: () => {
          this.$alert('הודעתך נשלחה בהצלחה!');
        },
      });
    },

    scroll_to_season(id) {
      var container = this.$el.querySelector('.episodes.container');
      var elm = this.$el.querySelector('#ep_season_' + id);
      container.scrollTop = elm.offsetTop;
    },

    user_hover() {
      this.is_user_active = true;
      window.clearTimeout(this.is_user_active_timer);
      this.is_user_active_timer = setTimeout(() => {
        this.is_user_active = false;
      }, 2400);
    },

    save_user_watch_time() {
      var settings = {
        profile_id: this.profile.id,
        episode_id: this.item.episode.id,
        not_free_user: (this.get_me.is_active ? 1 : 0),
        item_id: this.item.episode.item_id,
        season_id: this.item.episode.season_id,
        duration: this.user_watch_time,
      };

      this.$http.post(window.api_url + 'user/update_time', settings);
    },

    onPlayerCreated(vjsPlayer) {
      var self = this;
      self.player = vjsPlayer;

      var saved_skip = JSON.parse(localStorage.getItem('user_restrictions'));
      var rest_flat = [];
      for (let z in self.episode.restrictions) {
        for (let i in self.episode.restrictions[z].items) {
          rest_flat.push(self.episode.restrictions[z].items[i]);
        }
      }
      for (let i in rest_flat) {
        if (!self.isNull(saved_skip) && saved_skip[rest_flat[i].id] === true) {
          self.auto_skip_rest.push(rest_flat[i]);
        }
      }

      self.updateInterval = setInterval(function() {
        if (self.is_playing) self.save_user_watch_time();
      }, 15000);

      // Derive the videojs constructor from the player instance (no global import needed).
      var videojs = vjsPlayer.constructor;

      var info_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function() { self.chat = !self.chat; },
      });
      var problam_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function() { self.active_problam = true; },
      });
      var open_espisodes_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function() { self.is_episodes_bar_opened = !self.is_episodes_bar_opened; },
      });
      var next_episode_btn = videojs.extend(videojs.getComponent('Button'), {
        handleClick: function() {
          self.$router.push('/item/' + self.next_episode.item_id + '/' + self.next_episode.id);
        },
      });
      var episode_name = videojs.extend(videojs.getComponent('Button'));

      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      vjsPlayer.controlBar.left_group.addChild(new info_btn()).addClass('info-btn');
      if (!isMobile) vjsPlayer.controlBar.left_group.addChild(new problam_btn()).addClass('problam_btn');

      if (self.next_episode && self.next_episode.id > 0) {
        vjsPlayer.controlBar.right_group.addChild(new next_episode_btn()).addClass('next-episode-btn');
      }
      if (self.item.type == 'series') {
        vjsPlayer.controlBar.right_group.addChild(new open_espisodes_btn()).addClass('open-espisodes-btn');
      }
      vjsPlayer.controlBar.right_group.addChild(new episode_name());

      self.initPreviewGuard();
    },

    onTimeupdate({ currentTime }) {
      this.user_watch_time = currentTime;
      this.trackPreview(currentTime);
      for (let i in this.auto_skip_rest) {
        let rest_item = this.auto_skip_rest[i];
        if (currentTime >= rest_item.time_start_seconds && currentTime <= rest_item.time_end_seconds) {
          this.$refs.videoPlayer.seek(rest_item.time_end_seconds);
        }
      }
    },
  },

  mounted() {
    var self = this;
    self.$emit('show_loader');

    this.api_call({
      url: 'items/get',
      data: { id: this.id, eid: this.eid },
      onComplete: function(data) {
        self.seasons = data.data.data.seasons;
        self.cur_season = self.seasons[0];
        self.item = data.data.data;
        self.episode = data.data.data.episode;

        self.opening_starts = self.episode.opening_starts;
        self.opening_ends = self.episode.opening_ends;

        if (self.episode.ending_starts > 0) self.ending_starts = self.episode.ending_starts;
        else self.ending_starts = self.episode.duration * 0.98;

        var curr_episode_found = false;
        for (var i in data.data.data.seasons) {
          for (var ep_i in data.data.data.seasons[i].episodes) {
            if (curr_episode_found) {
              self.next_episode = data.data.data.seasons[i].episodes[ep_i];
              break;
            }
            curr_episode_found = (data.data.data.seasons[i].episodes[ep_i].id == data.data.data.episode.id);
          }
          if (self.next_episode.id > 0) break;
        }

        self.loaded = true;
        self.$emit('loaded');

        self.restorePreviewState();
      },
    });
  },
};
</script>

<style scoped lang="scss">
/* ── Transition ── */
.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--duration-slow) var(--easing-default);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .fade-enter-active,
  .fade-leave-active {
    transition: none;
  }
}

/* ── Gated / inactive screen ── */
#unactive_screen {
  width: 50%;
  margin: 0 auto;
  padding: var(--space-8);
  margin-block-start: var(--space-12);
  text-align: center;
  font-size: var(--text-lg);
}

/* ── Hero background image ── */
.wb-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
  opacity: 0.35;
}

/* ── Inner content container ── */
.wb-inner {
  position: relative;
  z-index: 1;
}

/* ── Access / geo-block banner ── */
.wb-access-banner {
  display: inline-block;
  padding: var(--space-4) var(--space-6);
  background: rgba(225, 29, 42, 0.12);
  border: 1px solid rgba(225, 29, 42, 0.33);
  border-radius: var(--radius-md);
  color: var(--color-text);
  margin-block-start: var(--space-4);

  b {
    color: var(--color-accent);
  }

  p {
    margin-block: var(--space-2) 0;
    color: var(--color-textMuted);
    font-size: var(--text-base);
    line-height: 1.5;
  }

  div {
    color: var(--color-textMuted);
    font-size: var(--text-base);
    margin-block-end: var(--space-4);
  }
}

/* ── Back button ── */
.wb-back-btn {
  padding: 0;
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
  z-index: 5;
  height: 44px;
  width: 44px;
  min-width: 44px;
  min-height: 44px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border: none;
  border-radius: var(--radius-sm);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity var(--duration-fast) var(--easing-default);

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }

  /* Flip chevron for RTL (chevron-right reads as "back" in LTR; in RTL flip so arrow points left = back) */
  svg {
    transform: scaleX(-1);
  }

  :root[dir="rtl"] & svg,
  [dir="rtl"] & svg {
    transform: scaleX(1);
  }
}

/* ── Skip bubble buttons ── */
.wb-skip-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-2) var(--space-4);
  background: var(--color-accent);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-sm);
  font-size: var(--text-sm);
  font-family: var(--font-hebrew);
  font-weight: 600;
  cursor: pointer;
  min-height: 44px;
  min-width: 44px;
  transition: background var(--duration-fast) var(--easing-default);

  &:hover {
    background: var(--color-accentHover);
  }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }
}

/* ── Episodes sidebar scrollable container ── */
.container {
  position: relative;
  height: 400px;
  overflow: auto;
}

@media (prefers-reduced-motion: reduce) {
  .wb-back-btn,
  .wb-skip-btn {
    transition: none;
  }
}
</style>
